<!--  -->
<template>
  <el-pagination v-if="showPagination" @current-change="handleCurrentChange" :total="totalCount" :current-page="currentPage" :page-size="limit" layout="prev,pager,next" >
    <span class="rightPagination">
      {{currentPage}}/{{totalPage}}
    </span>
  </el-pagination>
</template>

<script>
export default {
  props: [
    "event",
    "showPagination",
    "limit",
    "totalPage",
    "totalCount",
    "nodeId",
  ],
  data() {
    return {
      currentPage: 1,
      show: true,
      //   limit: 5,
      //   totalPage: 100,
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    console.log("limit", this.limit);
    //   console.log(this.totalPage);
  },
  methods: {
    handleCurrentChange(value) {
      this.currentPage = value;
      let fn = this.event;
      fn(this.currentPage)
        .then((res) => {
          if (res.data?.data) {
            let result = res.data.data || [];
            let meta = res.data?.meta || {};
            this.$emit("getList", result);
          } else {
            this.currentPage = value - 1;
          }
        })
        .finally((_) => {
        });
    },
  },
  watch: {
    nodeId: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.$nextTick(() => {
          this.currentPage = 1;
        });
      }
    },
  },
};
</script>
<style>
.el-pagination {
  text-align: right;
  position: absolute;
  right: 0;
  bottom: 0;
}
.el-pagination .btn-next,
.el-pagination .btn-prev {
  width: 26px;
  height: 26px;
  min-width: unset !important;
  background: rgba(255, 255, 255, 0.6);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  padding: 0;
}
.el-pagination .btn-next:hover,
.el-pagination .btn-prev:hover {
  color: #72c2c9;
}
.el-pagination button:disabled {
  background: rgba(255, 255, 255, 0.6);
}
.el-pagination span:not([class*="suffix"]) {
  margin: 0 8px;
  font-size: 16px;
}
.el-pagination button, .el-pagination span:not([class*=suffix]){
    min-width: unset;
}
</style>